/** Query key factory. List keys include the full query (page, filters, sort) for caching. */
export const qk = {
  session: () => ["session"] as const,
  system: {
    all: ["system"] as const,
    health: () => ["system", "health"] as const,
    overview: () => ["system", "overview"] as const,
    metrics: () => ["system", "metrics"] as const,
    errors: (q?: object) => (q ? (["system", "errors", q] as const) : (["system", "errors"] as const)),
    events: (q?: object) => (q ? (["system", "events", q] as const) : (["system", "events"] as const)),
  },
  organizations: {
    all: ["organizations"] as const,
    list: (q: object) => ["organizations", "list", q] as const,
    detail: (id: string) => ["organizations", "detail", id] as const,
  },
  stores: {
    all: ["stores"] as const,
    list: (q: object) => ["stores", "list", q] as const,
    detail: (id: string) => ["stores", "detail", id] as const,
  },
  users: {
    all: ["users"] as const,
    list: (q: object) => ["users", "list", q] as const,
    detail: (id: string) => ["users", "detail", id] as const,
  },
  opportunities: {
    all: ["opportunities"] as const,
    list: (q: object) => ["opportunities", "list", q] as const,
    detail: (id: string) => ["opportunities", "detail", id] as const,
    timeline: (id: string) => ["opportunities", "timeline", id] as const,
    images: (id: string) => ["opportunities", "images", id] as const,
    notes: (id: string) => ["opportunities", "notes", id] as const,
  },
  conversations: {
    all: ["conversations"] as const,
    list: (q: object) => ["conversations", "list", q] as const,
    detail: (id: string) => ["conversations", "detail", id] as const,
    messages: (id: string) => ["conversations", "messages", id] as const,
    timeline: (id: string) => ["conversations", "timeline", id] as const,
    simulator: (id: string) => ["conversations", "simulator", id] as const,
    media: (messageId: string, index: number) => ["conversations", "media", messageId, index] as const,
  },
  appointments: { list: (q: object) => ["appointments", "list", q] as const },
  prompts: {
    all: ["prompts"] as const,
    settings: (organizationId: string | null) => ["prompts", organizationId ?? "global"] as const,
    followups: (organizationId: string | null) => ["prompts", "followups", organizationId ?? "global"] as const,
  },
  ai: {
    all: ["ai"] as const,
    summary: (range: string) => ["ai", "summary", range] as const,
    runs: (q: object) => ["ai", "runs", q] as const,
    run: (id: string) => ["ai", "run", id] as const,
  },
  queues: {
    all: ["queues"] as const,
    list: () => ["queues", "list"] as const,
    detail: (name: string) => ["queues", "detail", name] as const,
    jobs: (name: string, q?: object) => (q ? (["queues", "jobs", name, q] as const) : (["queues", "jobs", name] as const)),
    job: (name: string, id: string) => ["queues", "job", name, id] as const,
  },
  integrations: {
    all: ["integrations"] as const,
    list: () => ["integrations", "list"] as const,
    detail: (id: string) => ["integrations", "detail", id] as const,
    offerDrivers: () => ["integrations", "offer-drivers"] as const,
    offerList: () => ["integrations", "offer-list"] as const,
    offerDetail: (id: string) => ["integrations", "offer", id] as const,
    offerRuns: (id: string, q: object) => ["integrations", "offer", id, "runs", q] as const,
    opportunityOfferRuns: (opportunityId: string, q: object) => ["integrations", "opportunity-runs", opportunityId, q] as const,
    offerRun: (id: string) => ["integrations", "offer-run", id] as const,
  },
  purchases: {
    all: ["purchases"] as const,
    list: (q: object) => ["purchases", "list", q] as const,
    trace: (id: string) => ["purchases", "trace", id] as const,
  },
  analytics: (section: string, range: string) => ["analytics", section, range] as const,
  audit: {
    all: ["audit"] as const,
    list: (q: object) => ["audit", "list", q] as const,
    detail: (id: string) => ["audit", "detail", id] as const,
  },
  search: (q: string) => ["search", q] as const,
  staff: {
    all: ["staff"] as const,
    list: (q: object) => ["staff", "list", q] as const,
    detail: (id: string) => ["staff", "detail", id] as const,
  },
};
